<template>
	<div id="i-map-container">
		<div id="i-map" class="map-ol"></div>
	</div>
</template>

<style scoped>
	.map-ol {
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		padding: 2px;
		background-color: #ebebeb;
	}
</style>

<script>
import { EventBus } from '@/components/EventBus';

import 'ol/ol.css';
import * as Proj from 'ol/proj';
import Map from 'ol/Map';
import View from 'ol/View';

import TileWMS from 'ol/source/TileWMS';
import ImageWMS from 'ol/source/ImageWMS';
import TileLayer from 'ol/layer/Tile';
import ImageLayer from 'ol/layer/Image';
import Vector from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';


import OSM from 'ol/source/OSM';

import InteractionSelect from 'ol/interaction/Select';
import InteractionDragBox from 'ol/interaction/DragBox';

import * as Control from 'ol/control';

import {click} from 'ol/events/condition.js';
import * as Condition from 'ol/events/condition';

import {Circle, Fill, Stroke, Style} from 'ol/style';

const { RequestsUtils } = require("@/assets/js/scripts/utils/RequestsUtils");
const { Utils } = require('@/assets/js/scripts/utils/Utils');
const { MapStyles } = require('./MapStyles.js');
const { MapUtils } = require('@/assets/js/scripts/webgis/map/MapUtils.js');

export default {
	name: 'MiniMappa',
	props: [
      	'prop_configuration',
		'prop_layer_features',
		'prop_selected_layer_features'
	],

	components: {
	},

	created() {
		EventBus.$on("layer_visibility", (obj) => {
			let layerCod = obj.cod;
			let visible = obj.visible;
			
			//Sistema la visibilità.
			let layer = this.layerRegistry[layerCod];
			if (!Utils.isNullOrUndefined(layer)) {
				layer.setVisible(visible);
			}

		});

		EventBus.$on("layer_cql_filter", (obj) => {
			let layerCod = obj.cod;
			let cql = obj.cql;
			
			//Sistema la visibilità.
			let layer = this.layerRegistry[layerCod];
			if (!Utils.isNullOrUndefined(layer)) {
				let params = layer.getSource().getParams();
				params["cql_filter"] = cql;
				layer.getSource().updateParams(params);
			}
		});

		EventBus.$on("add_geojson_and_zoom", (layerName, layerIndex, styleFn, geom_json, opts) => {
			let layer = null;
			
			/*
			Crea se layer non esiste
			*/
			if (Utils.isNullOrUndefined(this.layerRegistry[layerName])) {
				layer = this.VEC_createVLayer(styleFn, layerIndex);
				this.layerRegistry[layerName] = layer;
			}
			else {
				layer = this.layerRegistry[layerName];
			} 
			
			//pulisco il VEC e aggiungo le nuove feat
			this.VEC_removeFeatures(layer);
			this.VEC_addFeaturesToLayer(layer, geom_json.features);
			let extent = MapUtils.getExtentFromFeaturesGeoJson(geom_json);
			MapUtils.zoomToExtent(this.mapInstance, extent, opts, 1);
		});

		EventBus.$on("remove_geojson", (layerName) => {
			let layer = this.layerRegistry[layerName];
			
			//pulisco il VEC
			this.VEC_removeFeatures(layer);
		});

		EventBus.$on("zoom_to_geojson", (geom_json, opts) => {
			let extent = MapUtils.getExtentFromFeaturesGeoJson(geom_json);
			MapUtils.zoomToExtent(this.mapInstance, extent, opts, 1);
		});

		EventBus.$on("toggle_selection", (obj) => {
			//Toggla controllo di selezione
		});
	},

	mounted() {
		if (this.mapInstance == null && this.configuration != null) {
			this.initMap();
		}
		this.isMounted = true;
		//this.redrawMap();
	},

	data() {
		return {
			isMounted: false,

			configuration: null,

         	mapInstance: null,
			
			selectedFeatures: {},

			layerRegistry: {},
		
			/*
			 * Per modalità GetFeatureInfo
			 */
			//selectionMode: "gfi",
			selectionMode: "vec",
		
			GFI_wmsLayer: null,
			GFI_wmsLayerShowTiled: true,
			GFI_vLayerSelezione: null,
			GFI_selectedFeaturesInfo: {},
			
			/*
			 * Per modalità "vettoriale pura"
			 */
			VEC_vLayer: null,
			VEC_selectControl: null
		}
	},

	methods: {
        /**
		 * Aggiorna le feature selezionate in mappa da una lista di attributi
		 * 
		 */
		VEC_updateSelectedFeatureFromProps: function(listOfAttributes) {
			if (Utils.isNullOrUndefined(this.VEC_vLayer)) {
				return;
			}
			
			var attributeCod = this.configuration.attributeFieldForSelect;
			var existingFeats = this.VEC_vLayer.getSource().getFeatures();
			
			/*
			 * TODO: sistemare!
			 * Per adesso svuota tutte le feature e le riseleziona!!!
			 * Fa il lavoro 2 volte se la selezione è stata fatta da mappa.
			 */
			this.VEC_selectControl.getFeatures().clear();

			if (Utils.isNullOrUndefined(listOfAttributes)) {
				return;
			}

            listOfAttributes.forEach(attr => {

                existingFeats.forEach(feat => {
                    if (feat.getProperties()[attributeCod] === attr) {
						//Beccata -> va aggiunta alla selezione
						this.VEC_selectControl.getFeatures().push(feat);
					}
                });
            });

			// $.each(listOfAttributes, function(idx, attr) {
				
			// 	$.each(existingFeats, function(fidx, feat){
			// 		if (feat.getProperties()[attributeCod] === attr) {
			// 			//Beccata -> va aggiunta alla selezione
			// 			vue.VEC_selectControl.getFeatures().push(feat);
			// 		}
			// 	});
			// });
		},
		
		VEC_removeFeatures: function(vectorLayer) {
			if (!Utils.isNullOrUndefined(vectorLayer)) {
				vectorLayer.getSource().clear();	
			}
		},
		
		/**
		 * Aggiunge una feature GeoJson ad un layer
		 */
		VEC_addFeaturesToLayer: function(vectorLayer, featuresGeoJson) {
			
			//Rimuovere prima le vecchie???
			if (Utils.isNullOrUndefined(featuresGeoJson)) {
				return;
			}
			
			if(!Utils.isNullOrUndefined(vectorLayer) && !Utils.isNullOrUndefined(this.mapInstance)) {

                featuresGeoJson.forEach(featureGeoJson => {
                    var olFeature = MapUtils.featureGeoJsonToFeature(featureGeoJson);
					vectorLayer.getSource().addFeature(olFeature);	
                });
            }
		},
		
		redrawMap : function() {
			if (!Utils.isNullOrUndefined(this.mapInstance)) {
				this.mapInstance.updateSize();
			}
		},
		
		GFI_createSelection: function() {
			/*
			 * Estraggo i codici degli oggetti
			 */
			var attributeCod = this.configuration.layer.attributeFieldForSelect;
			
			var list = [];
			//var vue = this;
            this.GFI_selectedFeaturesInfo.forEach(featInfo => {
                var val = featInfo.properties[attributeCod];
				list.push(val);
            });

			// $.each(this.GFI_selectedFeaturesInfo, function(idx, featInfo){
				
			// 	var val = featInfo.properties[attributeCod];
			// 	list.push(val);
			// });
			
			return list;
		},

		buildTiledLayer(layerName, url, format) {
			let wmsVersion = '1.1.1';
			let tileWmsSource = new TileWMS({
				url: url,
				params: {'FORMAT': format, 
						'VERSION': wmsVersion,
						tiled: true,
						"LAYERS": layerName,
						"exceptions": 'application/vnd.ogc.se_inimage'
				}
			});

			let tiled = new TileLayer({
		        visible: this.GFI_wmsLayerShowTiled,
		        source: tileWmsSource
		    });

			return tiled;
		},

		buildUntiledLayer(layerName, url, format) {
			let wmsVersion = '1.1.1';

			let imageWmsSource = new ImageWMS({
				ratio: 1,
				url: url,
				params: {'FORMAT': format,
						'VERSION': wmsVersion,  
						"LAYERS": layerName,
						"exceptions": 'application/vnd.ogc.se_inimage',
				}
			});

			let untiled = new ImageLayer({
				visible: !this.GFI_wmsLayerShowTiled,
				source: imageWmsSource
			});

			return untiled;

		},
		
		buildLayers: function() {
			let registry = {};
			//let layers = [];
			if (!Utils.isNullOrUndefined(this.configuration.layers)) {
				this.configuration.layers.forEach(lay => {
					let layerName = lay.layerName;
					let url = lay.url;
					let format = lay.format;
					let cod = lay.cod;
					// let type = lay.type;
					
					//Di default è visibile
					let visible = Utils.isNullOrUndefined(lay.visible)? true : lay.visible;

					let layer = this.buildTiledLayer(layerName, url, format);
					layer.setVisible(visible);
					registry[cod] = layer;
					
				});
			}
			return registry;
		},

		// buildWMSLayerForSelection: function() {
		// 	var layerName = this.configuration.layer.layerName;
		// 	var url = this.configuration.layer.url;
		// 	var format = this.configuration.layer.format;
			
		// 	var wmsVersion = '1.1.1';
		//       if (this.GFI_wmsLayerShowTiled === true) {
		//     	  this.GFI_wmsLayer = tiled;
		//       } else {
		//     	  this.GFI_wmsLayer = untiled;
		//       }
		// }
		
		createVectorLayer: function(optionalStyleFn) {
			
			//Default style
			var featureStyle = MapStyles.highlight;
			
			if (!Utils.isNullOrUndefined(this.configuration.featureStyle)) {
				//Se specificato un altro stile vado di override
				featureStyle = MapStyles[this.configuration.featureStyle];
			}

			if (!Utils.isNullOrUndefined(optionalStyleFn)) {
				featureStyle = MapStyles[optionalStyleFn];
			}

			var properties = {
				source: new VectorSource({
					projection: this.epsg
				}),
				updateWhileAnimating: true,
				updateWhileInteracting: true,
				style : featureStyle
			};
			
			// Crea il layer con le properties specificate
			var vectorLayer = new Vector(properties);
			
			// vectorLayer.set("name", "nome");
			//vectorLayer.set("type", MapLayerManagerTypes.vector);
			// vectorLayer.set("selectable", false);
			// vectorLayerHighlight = mapLayerManager.initVector("nome",
			// 'EPSG:32632', MapStyles.OL4.featureInfo.highlight, false);
			vectorLayer.setVisible(true);
			
			return vectorLayer;
		},
		
		GFI_createVLayerSelezione : function() {
			let vectorLayer = this.createVectorLayer();
			this.mapInstance.addLayer(vectorLayer);
			this.GFI_vLayerSelezione = vectorLayer;
	    },
	    
	    VEC_createVLayer : function(optionalStyleFn, optionalLayerIdx) {
			let vectorLayer = this.createVectorLayer(optionalStyleFn);
	    	vectorLayer.set("name", "vLayer");

			//Imposto z-index layer se specificato
			if (!Utils.isNullOrUndefined(optionalLayerIdx)) {
				vectorLayer.setZIndex(optionalLayerIdx);
			}

			this.mapInstance.addLayer(vectorLayer);


			return vectorLayer;
	    },
	    
	    createFeatureFromGeometry : function(geoJsonGeometry, properties) {
	    	// Crea una geometria da una WKT geometry
	  	  	let geometry = MapUtils.geoJsonToGeom(geoJsonGeometry);

	        let feature = MapUtils.createFeatureFromGeometry(geometry, {});
	        return feature;
	    },
	    
	    GFI_isFeatureAlreadySelected : function(featureInfo) {
			if (Utils.isNullOrUndefined(this.GFI_selectedFeaturesInfo[featureInfo.id])) {
				return false;
			}
			return true;
		},
		
		GFI_addFeatureToSelected : function(featureInfo, feature) {
			this.GFI_selectedFeaturesInfo[featureInfo.id] = featureInfo;
			this.selectedFeatures[featureInfo.id] = feature;
		},
		
		GFI_removeFeatureFromSelected : function(featureInfo) {
			if (this.GFI_isFeatureAlreadySelected(featureInfo)) {
				
				delete this.GFI_selectedFeaturesInfo[featureInfo.id];
				delete this.selectedFeatures[featureInfo.id];
			}
		},
		
		initMap: function() {
			let baseLayer = this.getBaselayer();

			let layers = [];
			layers.push(baseLayer);
			
			let additionalLayerRegistry = this.buildLayers();
			this.layerRegistry = additionalLayerRegistry;

			for (let j in additionalLayerRegistry) {
				let lyr = additionalLayerRegistry[j];
				layers.push(lyr);
			}

			this.layerRegistry["BASELAYER"] = baseLayer;
			
			let projection = new Proj.Projection({
                code: this.configuration.epsg,
                units: 'm',
                axisOrientation: 'neu',
                global: false
            });
						
			// //Init reprojection
			let destEpsg = this.configuration.epsg;
			let centerCoordsWGS84 = this.configuration.centerCoordsWGS84;
			let initzoom = this.configuration.initZoom;
			let coords = MapUtils.reprojectCoords(centerCoordsWGS84, "EPSG:4326", destEpsg);
			
			let view = new View({
				projection: destEpsg,
				center: coords,
				zoom: initzoom
			});
			
			// var mousePositionControl = new ol.control.MousePosition({
			// 	className: 'custom-mouse-position',
		    //     target: document.getElementById('location'),
		    //     coordinateFormat: ol.coordinate.createStringXY(5),
		    //     undefinedHTML: '&nbsp;'
		    // });
			
			let map = new Map({
				layers: layers,
		        target: "i-map",
		        controls: Control.defaults({
		          attributionOptions: {
		            collapsible: false
		          }
		        }),
                // .extend([mousePositionControl]),
				// interactions: ol.interaction.defaults().extend([
				// new ol.interaction.DragRotateAndZoom({})
				// ]),
		        view: view
		    });
			
			this.mapInstance = map;
			
			if (this.selectionMode === "gfi") {
				// Selezione con GetFeatureInfo (WMS)
				
				map.addLayer(this.GFI_wmsLayer);
				this.GFI_createVLayerSelezione();	
			}
			
			if (this.selectionMode ==="vec") {
				// Selezione da layer Vettoriale
				let styleFn = null;
				let layerZIdx = 1;
				this.VEC_vLayer = this.VEC_createVLayer(styleFn, layerZIdx);
				this.layerRegistry["VECTOR"] = this.VEC_vLayer;
			}
			
			this.addCallbacks();
			
		},
		
		getBaselayer: function() {
			let baselayer = new TileLayer({
		    	source: new OSM()
		    });
			return baselayer;
		},
		
		addCallbacks: function() {
			var map = this.mapInstance;
			var vue = this;
			
			// Change resolution
			// map.getView().on('change:resolution', this.onMapChangeResolution);
			
			// Map click
			if (this.selectionMode === "gfi") {
				map.on('singleclick', this.onGetFeatureInfoClick);	
			}
			
			let multipleSelection = true;
			if (!Utils.isNullOrUndefined(this.configuration.multipleSelection)) {
				multipleSelection = this.configuration.multipleSelection;
			}

			if (this.selectionMode === "vec") {

				let selectOptions = {
					layers: [this.VEC_vLayer],
					wrapX: false,
					condition: click
				};

				if (multipleSelection == true) {
					selectOptions.multi = true;
					selectOptions.removeCondition = click;
					selectOptions.addCondition = click;
				}
				
				if (this.configuration.selectByBox === false) {
					let select = new InteractionSelect(selectOptions);
					map.addInteraction(select);
				    this.VEC_selectControl = select;
				    select.on('select', this.onSelectFeatureClick);
				}
				else {
					var selectDraw = new InteractionSelect(selectOptions);
					map.addInteraction(selectDraw);
				    this.VEC_selectControl = selectDraw;
				    selectDraw.on('select', this.onSelectFeatureClick);
				    
					var draw = new InteractionDragBox({
						style: new Style({
							stroke: new Stroke({
								color: [0, 0, 255, 1]
							})
						}),
						condition: Condition.platformModifierKeyOnly
					});
					map.addInteraction(draw);
					
					//Evento draw-end
					draw.on('boxend', function(e) {
						//var control = self.selectFeatureByDragbox;
						var extent = draw.getGeometry().getExtent();
						
						var selectedFeaturesFromControl = selectDraw.getFeatures();
						selectedFeaturesFromControl.clear();
						
						var selectedFeatures = [];
							
						var vectorSource = vue.VEC_vLayer.getSource();
						vectorSource.forEachFeatureIntersectingExtent(extent, function(feature) {
							// Inserisce la feature da restituire alla callback
//							if($.inArray(feature, selectedFeatures) > -1) {
//								return true;
//							}
							
							// Aggiunge la feature al controllo di select
							selectedFeaturesFromControl.push(feature);
							
							selectedFeatures.push(feature);
						});
						//control.callback(selectedFeatures);
						vue.onSelectFeaturesBox(selectedFeatures);
					});
				}
			}
		},
		
		onMapChangeResolution : function(evt) {
			var map = this.mapInstance;
			
			var resolution = evt.target.get('resolution');
	        var units = map.getView().getProjection().getUnits();
	        var dpi = 25.4 / 0.28;
	        var mpu = Proj.METERS_PER_UNIT[units];
	        var scale = resolution * mpu * 39.37 * dpi;
	        if (scale >= 9500 && scale <= 950000) {
	          scale = Math.round(scale / 1000) + "K";
	        } else if (scale >= 950000) {
	          scale = Math.round(scale / 1000000) + "M";
	        } else {
	          scale = Math.round(scale);
	        }
	        document.getElementById('scale').innerHTML = "Scale = 1 : " + scale;  
		},
		
		/**
		 * Usata per la selezionate dei layer vettoriali
		 * via BOX
		 */
		onSelectFeaturesBox: function(features) {
			var numSel = features.length;
	    	
			var attributeCod = this.configuration.attributeFieldForSelect;
	    	var list = [];
	    	
	    	for(var j=0; j<numSel; j++) {
	    		var feat_j = features[j];
	    		//var layer = evt.target.getLayer(feat_j);
	    		//var ge = feat_j.getGeometry();
	    		var properties = feat_j.getProperties();
	    		var val = properties[attributeCod];
	    		list.push(val);
	    	}
	    	
	    	/*
			 * Sollevo evento di aggiornamento features
			 */
            this.$emit('update-selection', list);
		},
		
		
		/**
		 * Usata per la selezione dei layer vettoriali
		 */
		onSelectFeatureClick: function(evt) {
	    	//var selectInteraction = evt.target;
	    	var selectInteraction = this.VEC_selectControl;
	    	var ns = evt.selected.length;
	    	var ds = evt.deselected.length;
	    	
	    	var numSel = selectInteraction.getFeatures().getLength();
	    	var features = selectInteraction.getFeatures();
	    	
	    	var attributeCod = this.configuration.attributeFieldForSelect;
	    	var list = [];
	    	
	    	for(var j=0; j<numSel; j++) {
	    		var feat_j = features.item(j);
	    		
	    		if (Utils.isNullOrUndefined(feat_j)) {
	    			console.log("feature null. Errore.");
	    			continue;
	    		}
	    		//var layer = evt.target.getLayer(feat_j);
	    		//var ge = feat_j.getGeometry();
	    		var properties = feat_j.getProperties();
	    		var val = properties[attributeCod];
	    		list.push(val);
	    	}
	    	
	    	/*
			 * Sollevo evento di aggiornamento features
			 */
            this.$emit('update-selection', list );
		},
		
		/**
		 * Al GetFeatureInfo
		 */
		onGetFeatureInfoClick : function(evt) {
			
			var self = this;
			
			var map = self.mapInstance;
			
			// document.getElementById('nodelist').innerHTML = "Loading...
			// please wait...";
			
	        var view = map.getView();
	        var viewResolution = view.getResolution();
	        var source = self.GFI_wmsLayer.getSource();
	        
	        var url = source.getGetFeatureInfoUrl(
	          evt.coordinate, viewResolution, view.getProjection(),
	          {'INFO_FORMAT': 'application/json', 'FEATURE_COUNT': 50});
	        
	        
	        if (url) {
	          console.log("URL per GFI: " + url);
	          // document.getElementById('nodelist').innerHTML = '<iframe
				// seamless src="' + url + '"></iframe>';
	          
	          self.doGetFeatureInfoCall(url, function(featureInfoResponse){

	            /*
				 * Come risposta ho una featurecollection
				 */
	            // alert('ok, got response');
	            if(featureInfoResponse == null || featureInfoResponse.features == null || featureInfoResponse.features.length === 0) {
	              // alert('response no data');
	              return;
	            } 
	            /*
				 * Ho dati, li mostro
				 */
	            var featureInfoList = featureInfoResponse.features;
	            var layer = self.GFI_vLayerSelezione;
	            
	            //$.each(featureInfoList, function(index, featureInfo) {
                featureInfoList.forEach(featureInfo => {
	              /*
					 * FEATURE
					 */
	            	// Evidenzia la feature in mappa se presente una geometria
	                if(Utils.isNullOrUndefined(featureInfo.geometry)) {
	                	return true;
	                }
	                
	            	if (!self.GFI_isFeatureAlreadySelected(featureInfo)) {
	            		let feature = self.createFeatureFromGeometry(featureInfo.geometry);
	            		self.GFI_addFeatureToSelected(featureInfo, feature);
	                    
	            		if(!Utils.isNullOrUndefined(layer) && !Utils.isNullOrUndefined(feature)) {
	                    	layer.getSource().addFeature(feature);
	                    }

	            	} else {
	            		let feature = self.selectedFeatures[featureInfo.id];
	            		self.GFI_removeFeatureFromSelected(featureInfo);
	            		if(!Utils.isNullOrUndefined(layer) && !Utils.isNullOrUndefined(feature)) {
	                    	layer.getSource().removeFeature(feature);
	                    }
	            	}
	            });

	            /*
				 * Sollevo evento di aggiornamento features
				 */
	            self.$emit('update-selection', self.GFI_createSelection() );
	            
	        });
	       }
		},
		
		/**
		 *  Effettua lo zoom all'estensione del layer vettoriale
		 */
		zoomToDataExtent : function(layer) {
			if (Utils.isNullOrUndefined(layer)) {
				return;
			}
			
			var source = layer.getSource();
			var extent = source.getExtent();
			
			var options = {};
			options.size = this.mapInstance.getSize();
			options.padding = [ 30, 30, 30, 30 ];
			this.mapInstance.getView().fit(extent, options);
		},
		
		doGetFeatureInfoCall : function(url, callbackOk) {

			RequestsUtils.get(
					url,
					// Params
					{},
					// Success Callback
					function (response) {
						if (callbackOk != null) {
							callbackOk(response);
						}
					}.bind(this),
					// Fail Callback
					null,
					// Show Message success
					false,
					// Show Loading
					true
			);
	   }

	},
    watch: {
		prop_configuration: {
			immediate : true, 
			handler: function(newVal, oldVal) {
				if (newVal != null) {
					this.configuration = newVal;
					if (this.isMounted == true && Utils.isNullOrUndefined(this.mapInstance)) {
						this.initMap();
					}
				}
			}
		},
		
		prop_layer_features: {
			immediate : true, 
			handler: function(newVal, oldVal) {
				if (newVal == null || newVal.length === 0) {
					console.log("prop_layer_features null.. pulisco il vec");
					this.VEC_removeFeatures(this.VEC_vLayer);
					return;
				}
				
				if (Utils.isNullOrUndefined(this.mapInstance)) {
					console.log("Map not defined... aborting");
					return;
				}
				
				if (this.selectionMode === "vec") {
					//pulisco il VEC e aggiungo le nuove feat
					this.VEC_removeFeatures(this.VEC_vLayer);
					this.VEC_addFeaturesToLayer(this.VEC_vLayer, newVal);
					
					//zoom to dataextent
					this.zoomToDataExtent(this.VEC_vLayer);
					
				}
			}
		},
		
		prop_selected_layer_features: {
			immediate : true, 
			handler: function(newVal, oldVal) {
				if (this.selectionMode === "vec") {
					this.VEC_updateSelectedFeatureFromProps(newVal);	
				}
				
			}
		}
	},
}
</script>